<template>
  <b-container fluid>
    <!-- Form Adjustment Running Hours Sidebar -->
    <CustomSidebar
      v-model="showCanvas"
      :title="selectedData ? 'Detail Adjustment Running Hours' : 'Create Adjustment Running Hours'"
      size="xl"
    >
      <div class="bg-white shadow-sm p-4" style="border-radius: 10px">
        <FormAdjustmentRunningHours
          v-if="showCanvas"
          :selectedData="selectedData"
          @refetch="fetchData"
          @close="showCanvas = false"
        />
      </div>
    </CustomSidebar>

    <iq-card>
      <template #headerTitle>
        <h5 class="card-title text-primary">
          <strong>ADJUSTMENT RUNNING HOUR</strong>
        </h5>
      </template>
      <template #body>
        <b-row>
          <FilterRh :filters="filters" />
          <b-col md="6" class="d-flex justify-content-end">
            <b-button
              variant="primary"
              style="height: max-content"
              @click=";(showCanvas = true), (selectedData = null)"
            >
              Create Adjustment Running Hours
            </b-button>
          </b-col>
          <b-col md="12">
            <table class="w-100 table-striped">
              <thead>
                <th>FLEET</th>
                <th>TRANSACTION ID</th>
                <th>CREATOR BY</th>
                <th>EFFECTIVE DATE</th>
                <!-- <th>STATUS</th> -->
                <th>ACTION</th>
              </thead>
              <tbody v-if="!loading">
                <template v-for="(item, i) in adjustments.data">
                  <tr :key="`${i}`">
                    <td>
                      <b-badge variant="success">
                        {{ item.vehicle?.name }}
                      </b-badge>
                    </td>
                    <td>
                      TRX-ADJSRH-{{ item?.id }}-{{
                        item?.effective_date
                          ? moment(item?.effective_date).format('MMYYYY')
                          : ''
                      }}
                    </td>
                    <td>
                      {{ item?.user?.requestor?.name ?? '-' }}
                    </td>
                    <td>{{ item?.effective_date ?? '-' }}</td>
                    <!-- <td>
                      <b-alert
                        show
                        class="p-0 m-0 text-capitalize d-flex justify-content-center"
                        style="width: 100px; border-radius: 4px"
                        :variant="getVariant(item?.state)"
                        >{{ item?.state }}</b-alert
                      >
                    </td> -->
                    <td style="width: 120px">
                      <b-dropdown
                        text="Action"
                        size="sm"
                        variant="outline-primary"
                      >
                        <b-dropdown-item
                          @click="
                            () => {
                              showCanvas = true
                              selectedData = item
                            }
                          "
                        >
                          View Detail Transaction
                        </b-dropdown-item>
                        <!-- <b-dropdown-item @click="handleDelete(item)">
                          Delete Transaction
                        </b-dropdown-item> -->
                        <template v-if="item?.state == 'requested'">
                          <b-dropdown-item
                            @click="() => handleConfirm(item, 'approve')"
                          >
                            <i class="fa fa-thumbs-up text-success mr-1"></i>
                            Approved
                          </b-dropdown-item>
                          <b-dropdown-item
                            @click="() => handleConfirm(item, 'reject')"
                          >
                            <i class="fa fa-close text-danger mr-2"></i>
                            Rejected
                          </b-dropdown-item>
                        </template>
                      </b-dropdown>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <div
              v-if="loading"
              class="w-100 d-flex justify-content-center py-5"
            >
              <b-spinner></b-spinner>
            </div>
            <div
              v-if="!loading && !adjustments?.data?.length"
              class="w-100 d-flex justify-content-center py-4"
            >
              No Data Here!
            </div>

            <!-- Pagination Section -->
            <div
              v-if="adjustments?.data?.length"
              class="mt-4 d-flex align-items-center w-100 justify-content-between"
            >
              <p class="mb-0">
                Total Rows:
                <strong class="text-black">{{ adjustments.total }}</strong>
              </p>
              <div class="d-flex justify-content-end">
                <b-pagination
                  class="mb-0 mr-3"
                  @change="
                    (page) => {
                      adjustments.page = page
                      fetchData()
                    }
                  "
                  v-model="adjustments.page"
                  :total-rows="adjustments.total"
                  :per-page="adjustments.perPage"
                  first-number
                  align="center"
                ></b-pagination>
                <b-form-select
                  plain
                  v-model="adjustments.perPage"
                  :options="limitOptions"
                  style="width: 100px"
                  @input="fetchData"
                ></b-form-select>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>
    </iq-card>
  </b-container>
</template>
<script>
import UserTemplate from '@/src/components/global/Partial/UserTemplate.vue'
import FormAdjustmentRunningHours from './FormAdjustmentRunningHours.vue'
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
} from '@/src/Utils/helper'
import FilterRh from './FilterRh.vue'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import moment from 'moment'

export default {
  components: {
    FormAdjustmentRunningHours,
    UserTemplate,
    FilterRh,
    CustomSidebar,
  },
  name: 'AdjustmentRunningHourNew',
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      showModalFilter: false,
      showCanvas: false,
      selectedData: null,
      filterDate: '',
      limitOptions: limitOptions,
      adjustments: {
        page: 1,
        perPage: 10,
        totalPage: 1,
        total: 0,
        data: [],
      },
      statusOptions: [
        {
          name: 'Requested',
          value: 'requested',
        },
        {
          name: 'Rejected',
          value: 'rejected',
        },
        {
          name: 'Completed',
          value: 'completed',
        },
      ],
    }
  },
  methods: {
    ...maintenanceActions,
    ...pmsActions,
    ...fleetsActions,
    async handleAction(item, action) {
      try {
        const actMsg = action == 'reject' ? 'Reject' : 'Approve'
        const res = await this.saveAdjustmentRunningHourAction({
          action,
          id: item.id,
        })
        this.$swal(
          'Success',
          res?.data?.message ?? `Success ${actMsg} Adjusment Running Hours`,
          'success'
        )
        this.fetchData()
      } catch (error) {
        console.log(error)
        this.$swal(
          'Error',
          error.response?.data?.message ??
            `Failed ${actMsg} Adjusment Running Hours`,
          'error'
        )
      }
    },
    handleConfirm(data, action) {
      const actMsg = action == 'reject' ? 'Reject' : 'Approve'
      this.$swal({
        title: `${actMsg} Data?`,
        text: `Once ${actMsg}, this action cannot be reversed.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: actMsg,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.handleAction(data, action)
        }
      })
    },
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.adjustments?.page || 1,
          limit: this.adjustments?.perPage,
          month: moment(this.filters.month).format('MM'),
          year: moment(this.filters.month).format('YYYY'),
        }
        // Handle multiple vehicle selection
        if (
          this.filters.vehicle &&
          Array.isArray(this.filters.vehicle) &&
          this.filters.vehicle.length > 0
        ) {
          const vehicleIds = this.filters.vehicle.map((v) => v.id).join(',')
          params.vehicle_id = vehicleIds
        }
        const res = await this.getAdjustmentRhV3(params)
        this.adjustments.data = res?.data?.data
        this.adjustments.totalPage = res?.data?.pagination?.totalPages || 0
        this.adjustments.total = res?.data?.pagination?.total || 0
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    getVariant(status) {
      switch (status) {
        case 'requested':
          return 'primary'
        case 'approved':
        case 'completed':
          return 'success'
        case 'rejected':
          return 'danger'
        default:
          return 'secondary'
      }
    },
    handleDelete(data) {
      this.$swal({
        title: 'Delete Data?',
        text: `Data will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteAdjustmentRhV3(data.id)
          if (res.status !== 'success') {
            this.$swal(
              'Error',
              res.data.message ??
                'Something wrong with the server. Cannot get user data.',
              'error'
            )
          } else {
            this.fetchData()
            this.$swal(`Data deleted!`, 'success')
          }
        }
      })
    },
  },
  watch: {
    filters: {
      handler() {
        this.fetchData()
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
table th {
  padding: 8px 12px;
}
table td {
  padding: 8px 12px;
  color: black;
}
</style>
